import { BehaviorSubject } from 'rxjs';
import { UniversityFinderFilter } from '../models/university-finder-filter.model';
import * as i0 from "@angular/core";
/**
 * Shares the University Finder filter state between the landing page, the results page, and the filter-list
 * component. Mirrors {@link FlyingClubFinderFiltersService} (a root-provided BehaviorSubject).
 */
var UniversityFinderFiltersService = /** @class */ (function () {
    function UniversityFinderFiltersService() {
        this.universityFinderFilterSubject$ = new BehaviorSubject(new UniversityFinderFilter());
        this.universityFinderFilter = this.universityFinderFilterSubject$.asObservable();
    }
    UniversityFinderFiltersService.prototype.updateUniversityFinderFilters = function (universityFinderFilter) {
        this.universityFinderFilterSubject$.next(universityFinderFilter);
    };
    UniversityFinderFiltersService.ngInjectableDef = i0.defineInjectable({ factory: function UniversityFinderFiltersService_Factory() { return new UniversityFinderFiltersService(); }, token: UniversityFinderFiltersService, providedIn: "root" });
    return UniversityFinderFiltersService;
}());
export { UniversityFinderFiltersService };
